import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaBars, FaSignOutAlt, FaClipboardCheck, FaCalendarCheck, FaHardHat } from 'react-icons/fa';
import logo from '../assets/fortunehomecare-logo.png';
import { initials } from '../ui';

const NAV = [
  { section: 'Work', items: [
    { to: '/audits', label: 'Audits', icon: FaClipboardCheck },
    { to: '/bookings', label: 'Bookings', icon: FaCalendarCheck },
  ] },
  { section: 'Team', items: [
    { to: '/manage-staff', label: 'Field staff', icon: FaHardHat },
  ] },
];

const Shell = ({ vendor, logout, children }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <div className={`app-shell${open ? ' nav-open' : ''}`}>
      <aside className="sidebar">
        <div className="sidebar-brand">
          <img src={logo} alt="Fortune Home Care" />
          <span className="badge badge-green plain" style={{ marginLeft: 'auto' }}>Vendor</span>
        </div>
        <nav className="sidebar-nav">
          {NAV.map((group) => (
            <React.Fragment key={group.section}>
              <div className="nav-section">{group.section}</div>
              {group.items.map(({ to, label, icon: Icon }) => (
                <NavLink key={to} to={to} className="nav-link"><Icon /> {label}</NavLink>
              ))}
            </React.Fragment>
          ))}
        </nav>
        <div className="sidebar-foot">
          <div className="avatar">{initials(vendor.company_name)}</div>
          <div className="who">
            <strong>{vendor.company_name}</strong>
            <span>{vendor.company_email}</span>
          </div>
          <button className="icon-btn" onClick={logout} title="Sign out" aria-label="Sign out"><FaSignOutAlt /></button>
        </div>
      </aside>
      <div className="scrim" onClick={() => setOpen(false)} />
      <div className="main">
        <header className="topbar">
          <button className="icon-btn" onClick={() => setOpen(true)} aria-label="Open menu"><FaBars /></button>
          <img src={logo} alt="Fortune Home Care" />
        </header>
        {children}
      </div>
    </div>
  );
};

export default Shell;
